import React from 'react';

function NotificationHeader() {
  return (
    <div className="grid grid-cols-[200px,1fr,auto] gap-[20px] p-[20px]">
      <img src="/guidance/google-logo.png" className="h-[44px]" alt="google" />
      <img src="/guidance/searchField.png" className="h-[44px]" alt="search" />
      <img src="/guidance/actions.png" className="h-[24px]" alt="actions" />
    </div>
  );
}

export default NotificationHeader;
